import { Component, HostListener, OnInit } from '@angular/core';
import { isFunction, cloneDeep } from 'lodash';
import {
  messageBoxButtonsConfig,
  messageBoxType,
} from '@apps/vhq/src/app/common/enums/messagebox.enum';
import { IVMessageBox } from '@apps/vhq/src/app/common/interfaces/message-box/IVMessageBox';
import { VhqMessageBoxService } from '@apps/vhq/src/app/core/services/message-box/vhq-message-box.service';
import { IVMessageBoxConfiguration } from '@apps/vhq/src/app/common/interfaces/message-box/IVMessageBoxConfiguration';
import { Subject } from 'rxjs';

@Component({
    selector: 'vhq-message-box',
    templateUrl: './vhq-message-box.component.html',
    styleUrls: ['./vhq-message-box.component.scss'],
    standalone: false
})
export class VhqMessageBoxComponent implements OnInit {
  showMessageBox: boolean;
  messageBoxConfig$: Subject<IVMessageBoxConfiguration>;
  messageBoxConfig: IVMessageBoxConfiguration;
  messageBoxElements: IVMessageBox;

  constructor(messageBoxService: VhqMessageBoxService) {
    this.messageBoxConfig$ = messageBoxService.messageBoxConfig$;
  }

  @HostListener('document:keyup.escape', ['$event']) onKeyUpHandler(): void {
    this.handleKeyboardEvent();
  }

  ngOnInit(): void {
    this.messageBoxElements = messageBoxButtonsConfig[0];
    this.messageBoxConfig$.subscribe((result: IVMessageBoxConfiguration) => {
      if (result?.type) {
        this.showMessageBox = true;
        this.messageBoxConfig = result;
        this.messageBoxElements =
          result.type === messageBoxType.CUSTOM
            ? this.configureCustomMessageBox()
            : this.getMessageBoxConfig();
      }
    });
  }

  closeMessageBox(): void {
    this.showMessageBox = false;
    if (isFunction(this.messageBoxConfig.closeButtonCallback))
      this.messageBoxConfig.closeButtonCallback();
  }

  cancelMessageBox(): void {
    this.showMessageBox = false;
    if (isFunction(this.messageBoxConfig.cancelButtonCallback))
      this.messageBoxConfig.cancelButtonCallback();
  }

  affirmativeMessageBox(): void {
    this.showMessageBox = false;
    if (isFunction(this.messageBoxConfig.affirmativeButtonCallback))
      this.messageBoxConfig.affirmativeButtonCallback();
  }

  declineMessageBox(): void {
    this.showMessageBox = false;
    if (isFunction(this.messageBoxConfig.declineButtonCallback))
      this.messageBoxConfig.declineButtonCallback();
  }

  private getMessageBoxConfig(): IVMessageBox {
    const config = cloneDeep(
      messageBoxButtonsConfig.find(
        (configuration) => configuration.type === this.messageBoxConfig.type,
      ),
    );
    if (config) {
      if (this.messageBoxConfig.affirmativeButtonLabel)
        config.affirmationButton.title = this.messageBoxConfig.affirmativeButtonLabel;
      if (this.messageBoxConfig.declineButtonLabel)
        config.declineButton.title = this.messageBoxConfig.declineButtonLabel;
    }
    return config;
  }

  private configureCustomMessageBox(): IVMessageBox {
    const config = this.getMessageBoxConfig();
    if (this.messageBoxConfig.customMessageBoxTitle)
      config.title = this.messageBoxConfig.customMessageBoxTitle;
    return config;
  }

  private handleKeyboardEvent(): void {
    if (this.showMessageBox) {
      this.closeMessageBox();
    }
  }
}
